// ============================================================
// Datei: ShiftTableMobile.jsx
// PURPOSE:
// Mobile Ansicht des Schichtplans
// - Long-Press öffnet Detail-Infoboard
// - Sichtbarkeits-Toggle triggert NUR Logik (kein Auto-Umschalten)
// ============================================================

import { useState, useRef } from "react";
import "./shiftTableMobile.css";

const LONG_PRESS_MS = 800;

const DAY_SHORT = {
    Montag: "Mo",
    Dienstag: "Di",
    Mittwoch: "Mi",
    Donnerstag: "Do",
    Freitag: "Fr",
    Samstag: "Sa",
    Sonntag: "So"
};


const ShiftTableMobile = ({
	shifts,
	onToggleVisibility
}) => {

	const [openShiftId, setOpenShiftId] = useState(null);
	const pressTimer = useRef(null);

	// ------------------------------------------------------------
	// Long-Press Handling
	// ------------------------------------------------------------
	const startPress = (shiftId) => {
		pressTimer.current = setTimeout(() => {
			setOpenShiftId(shiftId);
		}, LONG_PRESS_MS);
	};

	const cancelPress = () => {
		if (pressTimer.current) {
			clearTimeout(pressTimer.current);
			pressTimer.current = null;
		}
	};

	// ------------------------------------------------------------
	// Slots visualisieren
	// ------------------------------------------------------------
	const renderSlots = (shift) =>
		Array.from({ length: shift.requestedAmountOfVolunteers }).map((_, i) => {
			const helperName = shift.volunteerNames?.[i];

			return (
				<div
					key={i}
					className={`slot ${helperName ? "filled" : "free"}`}
				>
					<span className="slot-icon">👤</span>
					{helperName && <span className="slot-name">{helperName}</span>}
				</div>
			);
		});

	return (
		<div className="shift-mobile-list">
			{shifts.map((shift) => {

				const isFull =
					shift.bookedShift >= shift.requestedAmountOfVolunteers;

				const isOpen = openShiftId === shift.shiftId;

				return (
					<div
	key={shift.shiftId}
	className={`shift-mobile-wrapper
		${shift.publicSlots > 0 ? "has-public" : ""}
		${isFull ? "full" : ""}
	`}
>

						{/* ================= SCHICHT-KACHEL ================= */}
						<div
							className={`shift-card mobile
								${isFull ? "full" : ""}
								${shift.publicSlots > 0 ? "has-public" : ""}
							`}
							onTouchStart={() => startPress(shift.shiftId)}
							onTouchEnd={cancelPress}
							onTouchMove={cancelPress}
							onMouseDown={() => startPress(shift.shiftId)}
							onMouseUp={cancelPress}
							onMouseLeave={cancelPress}
						>
							<h4>{DAY_SHORT[shift.dayOfDeployment] ?? shift.dayOfDeployment}</h4>
							<p>{shift.startTime} – {shift.endTime}</p>
							<p>{shift.bookedShift}/{shift.requestedAmountOfVolunteers}</p>
							<p>{isFull ? "Belegt" : "Offen"}</p>
						</div>

						{/* ================= INFOBOARD ================= */}
						{isOpen && (
							<div className="shift-infoboard">

								<div className="infoboard-header">
									<div>
										<strong>Schichtdetails</strong>
										<p>Tag: {shift.dayOfDeployment}</p>
										<p>Zeit: {shift.startTime} – {shift.endTime}</p>
									</div>

									<div className="slot-visual">
										<div className="slot-count">
											Slots: {shift.bookedShift}/{shift.requestedAmountOfVolunteers}
										</div>
										{renderSlots(shift)}
									</div>
								</div>

								{/* ================= FOOTER ================= */}
								<div className="infoboard-footer">

									{/* Sichtbarkeit */}
									<div className="publish-block">
										<div className="publish-text">
											<span className="publish-title">
												Schicht publizieren
											</span>
											<span className="publish-count">
												{shift.publicSlots} von{" "}
												{shift.requestedAmountOfVolunteers} öffentlich
											</span>
										</div>

										<label className="toggle-switch">
											<input
												type="checkbox"
												checked={shift.shiftVisibility === "PUBLIC"}
												readOnly
												onClick={(e) => {
													e.preventDefault(); // 🔥 KRITISCH
													onToggleVisibility(shift);
												}}
											/>
											<span className="slider" />
										</label>
									</div>

									{/* Schliessen */}
									<button
										className="close-btn"
										onClick={() => setOpenShiftId(null)}
									>
										Schliessen
									</button>
								</div>
							</div>
						)}
					</div>
				);
			})}
		</div>
	);
};

export default ShiftTableMobile;
